<template>
  <div class="wrap">
    <div class="business">
      <div class="businessTitle">商务合作</div>
      <div class="businessEn">BUSINESS COOPERATION</div>
      <!-- <div class="shopBox">
        <img
          src="https://p1.ssl.qhimg.com/t110b9a9301d455f6a95ca03b51.png"
          alt=""
          class="shopBoxLogo"
        />
        <div class="shopBoxContent">
          <div class="shopBoxContentInfo">
            <div v-for="(item, index) in obj?.info" class="shopBoxContentInfoItem">
              <img :src="item.icon" alt="" class="shopBoxContentInfoItemIcon" />
              <div class="shopBoxContentInfoItemText">{{ item.text }}</div>
              <div class="shopBoxContentInfoItemName">{{ item.name }}</div>
            </div>
          </div>
          <div class="shopCode">
            <div class="shopCodeOne">
              <img
                src="https://p5.ssl.qhimg.com/t110b9a930108d87707772fb1ec.png"
                alt=""
                class="shopCodeImg"
              />
              <div class="shopCodeOneText">下载AI浏览器</div>
              <div class="shopCodeOneInfo">获取更多大会信息</div>
            </div>
            <div class="shopCodeTwo">
              <img
                src="https://p3.ssl.qhimg.com/t110b9a9301c41cb1ccf7c92166.png"
                alt=""
                class="shopCodeImg"
              />
              <div class="shopCodeTwoText">ISC 官方公众号</div>
            </div>
            <div class="shopCodeBox">
              <div class="shopCodeBoxHouse">
                <div class="shopCodeBoxHouseItem specailRed">
                  <img
                    src="https://p5.ssl.qhimg.com/t110b9a93016a73b8750e08e61c.png"
                    alt=""
                    class="shopCodeBoxHouseItemImg"
                  />
                  <div class="shopCodeBoxHouseItemText">@红衣大叔周鸿祎</div>
                </div>
                <div class="shopCodeBoxHouseItem">
                  <img
                    src="https://p4.ssl.qhimg.com/t110b9a9301b3c39d319e89f564.png"
                    alt=""
                    class="shopCodeBoxHouseItemImg"
                  />
                  <div class="shopCodeBoxHouseItemText">@红衣大叔周鸿祎</div>
                </div>
              </div>
              <div class="shopCodeBoxInfo">关注 @红衣大叔周鸿祎，解锁安全&AI最新知识</div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="shopContainer">
        <img src="https://p4.ssl.qhimg.com/t110b9a9301d0ae0e94e75020a1.png" alt="" class="shopContainerImg" />
      </div>
    </div>
    <img
      src="https://p0.ssl.qhimg.com/t110b9a9301870fa5c43355b1db.png"
      alt=""
      class="businessImg"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue'
const obj = ref({
  info: [
    {
      icon: 'https://p5.ssl.qhimg.com/t110b9a93014ef0f1a706e890ff.png',
      text: '联系人',
      name: '马欣'
    },
    {
      icon: 'https://p4.ssl.qhimg.com/t110b9a9301706969a4f294b4a0.png',
      text: 'Email',
      name: 'ISC@360.cn'
    },
    {
      icon: 'https://p3.ssl.qhimg.com/t110b9a93017dcd26616d0cda24.png',
      text: '电话',
      name: '15718876610'
    }
  ],
  codeArr: [
    {
      code: 'https://p2.ssl.qhimg.com/t110b9a93011fe71f0c0b364de4.png',
      text: 'ISC APP下载'
    },
    {
      code: 'https://p2.ssl.qhimg.com/t110b9a930144988647ab03aa11.png',
      text: '微信公众号'
    }
  ]
})
</script>

<style lang="scss" scoped>
.wrap {
  opacity: 1;
  background-color: #f3f3f3;
  padding-bottom: 131px;
  // background-color: pink;
}

.business {
  width: 90%;
  min-width: 1230px;
  margin: 0 auto;
  &Title {
    font-family: Source Han Sans;
    font-size: 48px;
    font-weight: 700;
    line-height: 48px;
    letter-spacing: 0px;
    font-variation-settings: 'opsz' auto;
    /* Gray 中性/gray-9 */
    color: #242933;
  }
  &En {
    margin-top: 16px;
    margin-bottom: 100px;
    font-family: Source Han Sans;
    font-size: 24px;
    font-weight: normal;
    line-height: 20px;
    letter-spacing: 0px;
    /* Gray 中性/gray-7 */
    color: #8a9099;
    display: inline-block;
  }
  &Img {
    display: block;
    width: 454px;
    position: absolute;
    bottom: 0;
    right: 0;
  }
}

.shop {
  display: flex;
  &Box {
    z-index: 20;
    width: 1600px;
    height: 430px;
    border-radius: 32px;
    opacity: 1;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(120px);
    padding: 70px 70px 0 64px;
    &Logo {
      width: 238px;
      margin-bottom: 58px;
    }
    &Content {
      display: flex;
      &Info {
        display: flex;
        border-right: 1px solid #e8eaed;
        margin-right: 80px;
        &Item {
          margin-right: 52px;
          &Icon {
            width: 48px;
            display: block;
            margin: 0 auto;
          }
          &Text {
            margin: 28px 0;
            font-family: Source Han Sans;
            font-size: 24px;
            font-weight: normal;
            line-height: 24px;
            letter-spacing: 0px;
            font-variation-settings: 'opsz' auto;
            /* Gray 中性/gray-7 */
            color: #8a9099;
            text-align: center;
          }
          &Name {
            font-family: Source Han Sans;
            font-size: 28px;
            font-weight: 500;
            line-height: 32px;
            letter-spacing: 0px;
            font-variation-settings: 'opsz' auto;
            /* Gray 中性/gray-9 */
            color: #242933;
            text-align: center;
          }
        }
      }

      // &Code {
      //   display: flex;
      //   column-gap: 120px;
      //   &Item {
      //     &Img {
      //       width: 150px;
      //     }
      //     &Text {
      //       text-align: center;
      //       font-family: Source Han Sans;
      //       font-size: 20px;
      //       font-weight: normal;
      //       line-height: 24px;
      //       letter-spacing: 0px;
      //       font-variation-settings: 'opsz' auto;
      //       /* Gray 中性/gray-8 */
      //       color: #525966;
      //     }
      //   }
      // }
    }
  }
  &Code {
    display: flex;
    &Img {
      width: 140px;
      margin: 0 auto;
      display: block;
    }
    &One {
      margin-right: 62px;
      width: 160px;
      font-family: Source Han Sans;
      font-size: 20px;
      font-weight: normal;
      line-height: 24px;
      letter-spacing: 0px;
      font-variation-settings: 'opsz' auto;
      /* Gray 中性/gray-9 */
      color: #242933;
      &Text {
        text-align: center;
        margin: 12px 0 8px;
      }
      &Info {
        text-align: center;
      }
    }
    &Two {
      width: 140px;
      margin-right: 67px;
      &Text {
        font-family: Source Han Sans;
        font-size: 20px;
        font-weight: normal;
        line-height: 24px;
        letter-spacing: 0px;
        font-variation-settings: 'opsz' auto;
        /* Gray 中性/gray-9 */
        color: #242933;
        margin-top: 27px;
      }
    }
    &Box {
      &Info {
        text-align: center;
        margin-top: 16px;
      }
      &House {
        display: flex;
        justify-content: center;
        &Item {
          width: 161px;
          // margin-right: 68px;
          &Img {
            margin: 0 auto;
            display: block;
          }
          &Text {
            margin-top: 12px;
            font-family: Source Han Sans;
            font-size: 20px;
            font-weight: normal;
            line-height: 24px;
            letter-spacing: 0px;
            font-variation-settings: 'opsz' auto;
            /* Gray 中性/gray-9 */
            color: #242933;
          }
        }
      }
    }
  }
  &Container {
    &Img {
      z-index: 20;
      width: 100%;
    }
  }
}

.specailRed {
  margin-right: 60px;
}
</style>
